import BlogIndex from "~/components/BlogIndex";
import { getBlogIndexProps } from "~/lib/blog-index";

export async function getStaticProps() {
  return getBlogIndexProps({});
}

export default BlogIndex;
